import { render, staticRenderFns } from "./Step2ColumnMapping.vue?vue&type=template&id=602ed062&scoped=true&"
import script from "./Step2ColumnMapping.vue?vue&type=script&lang=js&"
export * from "./Step2ColumnMapping.vue?vue&type=script&lang=js&"
import style0 from "./Step2ColumnMapping.vue?vue&type=style&index=0&id=602ed062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602ed062",
  null
  
)

export default component.exports